import axios from 'axios';

const api = axios.create({
  baseURL: (process.env.REACT_APP_LINYUAN_API_BASE || '') + '/api',
  timeout: 10000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('linyuan_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    // If backend returns { code: 200, data: ... }, unwrap it here if needed.
    // Based on LinyuanApi, it returns ApiResponse object directly.
    // ApiResponse usually has { code, message, data }.
    // Let's return response.data to match typical usage, or keep response if we need headers.
    // Most frontend code expects response.data or response directly.
    // ApiSelect expects response.data or response array.
    return response.data;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle logout or redirect
      // Dispatch custom event to notify AuthContext to logout
      window.dispatchEvent(new Event('auth:logout'));
    }
    return Promise.reject(error);
  }
);

export default api;
